import { DefaultCell } from "app/components/React/Table/cells";
import StatefullCell from "app/components/React/Table/cells/StatefullCell/StatefullCell";
import type { AssetsCountDto } from "app/pages/sales-intelligence/pages/home/types/dto";
import type { CellProps } from "app/pages/sales-intelligence/pages/home/types/table";
import { isNumericCellValueValid } from "../../../utils/isNumericCellValueValid";
import { StyledAssetLink, StyledCellWrapper } from "./styles";
import { numberFilter } from "app/filters/numberFilter";

type Props = CellProps<AssetsCountDto>;

const AssetsCountCell = ({ status, value, onClick, ...cellProps }: Props) => {
    const showAsLink = isNumericCellValueValid(value);
    const formattedValue = numberFilter()(value);

    const content = showAsLink ? (
        <StyledAssetLink
            data-automation="asset-link"
            onClick={onClick}
        >
            <DefaultCell
                {...cellProps}
                value={formattedValue}
                format="numberFilter"
            />
        </StyledAssetLink>
    ) : (
        <DefaultCell
            {...cellProps}
            value={formattedValue}
            format="numberFilter"
        />
    );

    return (
        <StyledCellWrapper>
            <StatefullCell status={status}>{content}</StatefullCell>
        </StyledCellWrapper>
    );
};

export default AssetsCountCell;
